// src/containers/KeywordIntentions/AddKeywordIntentions.js

import React from 'react'
import { useHistory } from 'react-router-dom'
import SetTitle from '../../utils/set_title'
import Header from '../../components/Headers/Header'
import KeywordIntentionsForm from './KeywordIntentionsForm'

export default function AddKeywordIntentions() {
  SetTitle('Add Keyword Intentions Analysis');
  const history = useHistory();
  const description = "Carica un file con la colonna 'Keyword', indica il nome della tabella su BigQuery e le email da notificare.";

  return (
    <Header
      iconClass="ni ni-favourite-28 text-white"
      title="Keyword Intentions"
      docLink="/docs/ranking_tools/keyword-intentions/"
      description={description}
    >
      <KeywordIntentionsForm onComplete={() => history.push('/keyword-intentions')} />
    </Header>
  );
}
